export default __webpack_public_path__ + "static/media/lightning.111d2069.svg";